import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  lang: {
      current: "en"
  },
  theme: {
    primary: "#607D8B",
    secondary: "#9C27B0",
    accent: "#FF5722"
  }

});
